export const tableGridColumns = '48px 1fr 1fr 64px 48px';
